import { render, staticRenderFns } from "./IncomingTenderList.vue?vue&type=template&id=4c87cb2c&"
import script from "./IncomingTenderList.vue?vue&type=script&lang=js&"
export * from "./IncomingTenderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports